module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-header-2fae8272348bfaec6daae078e88659f9.png";